import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as IconCross } from '../../../assets/icon/ic_close.svg';

const ClearIndicator = ({
  innerProps: { ref, onMouseDown, onTouchEnd },
}) => {
  return (
    <div
      role="presentation"
      ref={ref}
      onMouseDown={onMouseDown}
      onTouchEnd={onTouchEnd}
      className="flex"
    >
      <IconCross width={18} height={18} className="mr-[6px] text-text-second hover:text-primary-hover" />
    </div>
  );
};

ClearIndicator.propTypes = {
  innerProps: PropTypes.shape({
    ref: PropTypes.shape({}),
    onMouseDown: PropTypes.func,
    onTouchEnd: PropTypes.func
  }).isRequired
};

export default ClearIndicator;
